module.exports = __webpack_public_path__ + "img/arrow-right-white.2735f118.svg";